export const cilHighligt = ["24 24","<path d='M4.875 14.32l4.125 2.25v5.93h6v-5.93l4.125-2.25v-6.82h-14.25zM6.375 9h11.25v4.43l-4.125 2.25v5.32h-3v-5.32l-4.125-2.25z'></path><path d='M11.25 1.5h1.5v3.375h-1.5v-3.375z'></path><path d='M2.896 3.394l1.061-1.061 2.387 2.386-1.061 1.061-2.386-2.386z'></path><path d='M17.657 4.72l2.387-2.386 1.061 1.061-2.387 2.386-1.061-1.061z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-highligt.js
// module id = null
// module chunks = 